export default __webpack_public_path__ + "static/media/server-illustration-2.759ff537.svg";